/* ==================================================================
   VS | Collection Gallery — JavaScript
   Vanilla JS, no dependencies
   Handles: reveal animation when the grid scrolls into view
================================================================== */

(function () {
  'use strict';

  function VsCollectionGallery(section) {
    this.section = section;
    this.animation = section.getAttribute('data-animation') || 'none';
    this.reducedMotion = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false;

    this.observeReveal();
  }

  VsCollectionGallery.prototype.observeReveal = function () {
    var self = this;

    if (this.animation === 'none' || this.reducedMotion) {
      this.section.classList.add('vs-is-visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      this.section.classList.add('vs-is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            self.section.classList.add('vs-is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, threshold: 0.1 }
    );

    observer.observe(this.section);
  };

  var instances = new WeakMap();

  function initSection(section) {
    if (!section || instances.has(section)) {
      return;
    }
    instances.set(section, new VsCollectionGallery(section));
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-vs-collection-gallery]');
    sections.forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-vs-collection-gallery]');
    if (section) {
      initSection(section);
    }
  });
})();
